import { render } from "./TreeComponent.vue?vue&type=template&id=3009dcf1"
import script from "./TreeComponent.vue?vue&type=script&lang=js"
export * from "./TreeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__